import { useContext } from "react";

import { ViewPreferenceContext } from "~/contexts/view-preference";

export const useViewPreference = () => useContext(ViewPreferenceContext);
